import React from "react";
import { Modal } from "react-bootstrap";

import { resolveRichText } from "../../../utils/richText";
import "./ContentModal.scss";

const ContentModal = (props) => {
  return (
    <Modal.Body>
      {props.blok.content ? (
        <div
          dangerouslySetInnerHTML={resolveRichText(props.blok.content)}
        ></div>
      ) : null}
    </Modal.Body>
  );
};

export default ContentModal;